import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(({ theme }) => ({
  // react-checkbox-tree adds hidden checkbox inputs that are absolutely positioned and must anchor
  // to the tree itself, otherwise those inputs don't scroll with it. This avoids an issue we were seeing where
  // after scrolling toggling checkbox X would toggle checkbox Y.
  position: "relative",
  ".react-checkbox-tree ol ol": {
    paddingLeft: 16,
  },
  ".react-checkbox-tree label:hover, .rct-node-clickable:focus, .rct-node-clickable:hover": {
    backgroundColor: "transparent",
  },
  "& .rct-node-parent > span": {
    backgroundColor: theme.palette.biarri.secondary.whiteSmoke,
  },
  "& .rct-text": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    height: 34,
  },
  "& .rct-title": {
    fontSize: theme.typography.size.normal,
  },
  "& .rct-checkbox *": {
    width: 20,
    verticalAlign: "middle",
  },
  "& .rct-checkbox": {
    color: theme.palette.primary.main,
    "& .unchecked": {
      color: theme.palette.text.primary,
    },
  },
  "& .rct-collapse.rct-collapse-btn": {
    paddingInline: 2,
  },
  "& .rct-collapse": {
    display: "flex",
    alignItems: "center",
  },
  "& .rct-collapse *": {
    width: 20,
  },
  "& .rct-disabled .rct-checkbox": {
    color: theme.palette.text.disabled,
    opacity: 0.8,
  },
}));
